import React from "react";
import PropTypes from "prop-types";
import {
  withStyles,
  FormControl,
  Select,
  Icon,
  Grid,
  Typography,
  TextField,
  MenuItem,
  Input,
  Divider,
} from "@material-ui/core";
import "../assets/css/banner.css";


const banner_classnames = `content banner-div`;
class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      keywords: "",
      categories: "All Job Categories",
      entity: "All Entities"
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
    this.setState({
      [event.target.name]: event.target.value
    }, () => {
      this.updateFilter();
    });
  };

  updateFilter = () => {
    this.props.onClick(
      this.state.keywords,
      this.state.categories,
      this.state.entity
    );
  }

  render() {
    const { classes, jobCategories, entities } = this.props;
    return (
      <div className={banner_classnames}>
        {this.state.width}
        {this.state.width > 1260 ? (
          <div className="banner-content">
            <Typography class="banner-header">
              Start your dream job today
            </Typography>
            <Grid container direction="row" className="form-root">
              <Grid item sm={12} xl={12} className="div-filters">
                <Grid item xs={4} className="form-input-div">
                  <Icon className="icon">search</Icon>
                  <FormControl className="form-control">
                    <TextField
                      placeholder="All Postions, Entities, Keywords "
                      className="form-input"
                      InputProps={{
                        classes: {
                          root: classes.root,
                          underline: classes.underline
                        }
                      }}
                      name="keywords"
                      value={this.state.keywords}
                      onChange={this.handleChange}
                    />
                  </FormControl>
                </Grid>
                <Divider className="divider" />
                <Grid item xs={4} className="form-input-div">
                  <Icon className="icon">card_travel</Icon>
                  <FormControl className="form-control">
                    <Select
                      name="categories"
                      displayEmpty
                      value={this.state.categories}
                      onChange={this.handleChange}
                      className="select-div"
                      input={
                        <Input
                          classes={{
                            root: classes.root,
                            underline: classes.underline
                          }}
                          name="categories"
                          id="age-helper"
                          value={this.state.categories}
                        />
                      }
                    >
                      <MenuItem value="All Job Categories">
                        All Job Categories
                    </MenuItem>

                      {jobCategories &&
                        Object.entries(jobCategories)
                          .map(([key, value]) => <MenuItem value={key} key={key}>{key} ( {value} )</MenuItem>
                          )
                      }
                    </Select>
                  </FormControl>
                </Grid>
                <Divider className="divider" />
                <Grid item xs={4} className="form-input-div">
                  <Icon className="icon">filter_none</Icon>
                  <FormControl className="form-control">
                    <Select
                      name="entity"
                      displayEmpty
                      value={this.state.entity}
                      onChange={this.handleChange}
                      className="select-div"
                      input={
                        <Input
                          classes={{
                            root: classes.root,
                            underline: classes.underline
                          }}
                          name="categories"
                          id="age-helper"
                          value={this.state.entity}
                        />
                      }
                    >
                      <MenuItem value="All Entities">All Entities</MenuItem>

                      {entities &&
                        Object.entries(entities)
                          .map(([key, value]) => <MenuItem value={key} key={key}>{key} ( {value} )</MenuItem>
                          )
                      }

                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </div>
        ) : (
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
            >
              <Typography class="banner-header">
                Start your dream job today
            </Typography>
              <Grid container direction="column" className="form-root">
                <FormControl className="form-control">
                  <Icon className="icon">search</Icon>
                  <TextField
                    placeholder="All Postions, Entities, Keywords "
                    className="form-input"
                    name="keywords"
                    value={this.state.keywords}
                    onChange={this.handleChange}
                    InputProps={{
                      classes: {
                        root: classes.root,
                        underline: classes.underline
                      }
                    }}
                  />
                </FormControl>

                <FormControl className="form-control">
                  <Icon className="icon">card_travel</Icon>
                  <Select
                    name="categories"
                    displayEmpty
                    value={this.state.categories}
                    onChange={this.handleChange}
                    className="select-input"
                    input={
                      <Input
                        classes={{
                          root: classes.root,
                          underline: classes.underline
                        }}
                        name="categories"
                        id="age-helper"
                        value={this.state.categories}
                      />
                    }
                  >
                    <MenuItem value="All Job Categories">
                      All Job Categories
                  </MenuItem>

                    {jobCategories &&
                      Object.entries(jobCategories)
                        .map(([key, value]) => <MenuItem value={key} key={key}>{key} ( {value} )</MenuItem>
                        )
                    }
                  </Select>
                </FormControl>

                <FormControl className="form-control">
                  <Icon className="icon">filter_none</Icon>
                  <Select
                    name="entity"
                    displayEmpty
                    value={this.state.entity}
                    onChange={this.handleChange}
                    className="select-input"
                    input={
                      <Input
                        classes={{
                          root: classes.root,
                          underline: classes.underline
                        }}
                        name="enitity"
                        id="age-helper"
                        value={this.state.entity}
                      />
                    }
                  >
                    <MenuItem value="All Entities">All Entities</MenuItem>

                    {entities &&
                      Object.entries(entities)
                        .map(([key, value]) => <MenuItem value={key} key={key}>{key} ( {value} )</MenuItem>
                        )
                    }
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          )}
      </div>
    );
  }
}

const styles = {
  root: {
    color: "#999",
    height: "38px",
    lineHeight: "38px"
  },
  underline: {
    "&:hover:not($disabled):after": {
      border: "none"
    },
    "&:hover:not($disabled):before": {
      border: "none"
    },
    "&:before": {
      border: "none"
    },
    "&:after": {
      border: "none"
    }
  },
  menu: {
    color: "#333"
  }
};

Banner.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary"])
};

export default withStyles(styles)(Banner);
